import { render, staticRenderFns } from "./OtherSelection.vue?vue&type=template&id=3df23a60&scoped=true&"
import script from "./OtherSelection.vue?vue&type=script&lang=js&"
export * from "./OtherSelection.vue?vue&type=script&lang=js&"
import style0 from "./OtherSelection.vue?vue&type=style&index=0&id=3df23a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df23a60",
  null
  
)

export default component.exports